<!-- 课消类型 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="courseConsumeType" type="courseConsumeType" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-课消类型',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '课消类型：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const courseConsumeType = useQuery('courseConsumeType', props.value);

    return {
      courseConsumeType,
    };
  },
};
</script>
